<template>
  <v-row no-gutters justify="center" align="start" class="init-account-layout fill-height pt-10">
    <div class="bg-overlay">&nbsp;</div>
    <div class="init-account-content-wrapper mt-4 pt-8 pa-4">
      <v-row no-gutters justify="center" align="center">
        <img src="@/assets/logo_white_no_bg.png" class="banner-logo" />
      </v-row>
      <div class="init-account-content py-2 px-4">
        <template v-if="hasCompany">
          <div class="py-5 mb-2">
            <n-card class="pa-3" style="background-color: transparent !important; border-color: rgba(255,255,255, 0.3);">
              <v-row no-gutters justify="center" align="center" class="white--text font-weight-medium text-center">
                {{ company.name }}
              </v-row>
            </n-card>
          </div>
          <router-view></router-view>
        </template>
        <n-card class="mt-10 pa-3" style="background-color: transparent !important; border-color: rgba(255,255,255, 0.3);" v-else>
          <v-row no-gutters justify="center" align="center" class="white--text font-weight-medium text-center">
            Impossible de trouver une application à cette adresse
          </v-row>
        </n-card>
      </div>
    </div>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `LayoutAuth`,

  data: () => ({
  }),

  computed: {
    ...mapState(`model/client`, [`company`]),
    hasCompany() {
      return Boolean(this.company && this.company.id);
    },
  },
};
</script>

<style lang="scss">
.init-account-layout {

  .bg-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url("../assets/abstract-login-overlay.jpg");
    z-index: 1;
    background-size: cover;
    opacity: .3;
  }

  .init-account-content-wrapper {
    z-index: 2;
    background: #13169a;
    -webkit-box-shadow: 0px 0px 25px 0px rgba(50, 50, 50, 1);
    -moz-box-shadow:    0px 0px 25px 0px rgba(50, 50, 50, 1);
    box-shadow:         0px 0px 25px 0px rgba(50, 50, 50, 1);
    border-radius: 10px;
    width: 900px;
    max-width: 90%;
  }
  .init-account-content {
    color: #FFF;
  }
  .banner-logo {
    width: 80%;
    max-width: 250px;
  }

  // .company-name {
  //   color: #FFF;
  // }
}
</style>
